import Case from '../Case/Case';
import { childrenToStrings } from '../ChildrenToStrings/ChildrenToStrings';
import { UppercaseProps } from './Uppercase.type';

const Uppercase = ({ ariaLabel, children }: UppercaseProps) => {
    return (
        <Case ariaLabel={ariaLabel} caseType={'uppercase'}>{childrenToStrings(children)}</Case>
    );
};

export default Uppercase;